<template>
    <div>
        <Row style="margin-bottom:28px">
            <Col :span="24">
                <Input v-model="keywords" placeholder="请输入名称" style="width: 200px" @keydown.native.enter.prevent="search"/>
                <Button type="primary" @click="search">查询</Button>
                <Button type="primary" @click="add">添加</Button>
            </Col>
        </Row>
        <div style="width:100%">
            <Table ref="table" stripe :loading="loading" border :columns="t_columns" :data="t_data" :height="tableHeight"></Table>
            <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page :total="pagination.total" :page-size="pagination.per_page" show-total show-elevator show-sizer  @on-page-size-change="changeLimit"  @on-change="changePage" :transfer="true" :page-size-opts="pageSizeOpts"/>
            </div>
        </div>
        <Modal
            v-model="ModalShow"
            :title="title"
            >
            <Form ref="formValidate" :model="editFormItem" :rules="ruleValidate" :label-width="100">
                <FormItem label="菜单类型" prop="is_menu">
                    <RadioGroup v-model="editFormItem.is_menu">
                        <Radio label="1">
                            <span>菜单</span>
                        </Radio>
                        <Radio label="0">
                            <span>功能</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="终端" prop="terminal">
                    <Select v-model="editFormItem.terminal" placeholder="请选择" @on-change="terminalChange">
                        <Option value="1">PC</Option>
                        <Option value="2">小程序</Option>
                    </Select>
                </FormItem>
                <FormItem label="上级菜单" prop="pids">
                    <Cascader :data="menuData" v-model="editFormItem.pids" change-on-select @on-change="pidChange"></Cascader>
                </FormItem>
                <FormItem label="名称" prop="show_name">
                    <Input v-model="editFormItem.show_name" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="显示排序" prop="sort">
                    <Input v-model="editFormItem.sort" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="授权标识" prop="name">
                    <Input v-model="editFormItem.name" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="路由" prop="path">
                    <Input v-model="editFormItem.path" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="图标" prop="icon">
                    <Input v-model="editFormItem.icon" placeholder="请输入"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="handleSubmit ('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:"permissions",
    data(){
        return{
            tableHeight: 500,
            pageSizeOpts:[50,60,70,80,90,100],
            loading:false,
            keywords:"",
            page:1,
            limit:50,
            ModalShow:false,
            title:"",
            editFormItem:{
                is_menu:"0",
                terminal:'1',
                pids:[],
                show_name:"",
                sort:'100',
                name:"",
                icon:"",
                path:"",
                pid:""
            },
            ruleValidate:{
                terminal: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                is_menu: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                pids: [
                    { required: true, type: 'array', message: '请选择', trigger: 'change' }
                ],
                show_name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                sort: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ]
            },
            t_columns: [
                {
                    width: 60,
                    align: 'center',
                    title:"序号",
                    render: (h,params) => {
                        return h('span',
                        (params.index + 1) + (this.pagination.per_page * (this.pagination.current_page-1)))
                    }
                },
                {
                    title: '名称',
                    key: 'show_name',
                    align: 'center',
                },
                {
                    title: '排序',
                    key: 'sort',
                    align: 'center',
                },
                {
                    title: '类型',
                    key: 'is_menu',
                    align: 'center',
                    render: (h, params) => {
                        let is_menu = params.row.is_menu
                        let str = ''
                        if(is_menu === 1){
                            str = "菜单"
                        }else if(is_menu === 0){
                            str = "功能"
                        }
                        return h('div', [
                            h('span', {
                            }, str)
                        ]);
                    }
                },
                {
                    title: '权限标识',
                    key: 'name',
                    align: 'center',
                },
                {
                    title: '路由',
                    key: 'path',
                    align: 'center',
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.edit(params.row.id)
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.remove(params.row.id)
                                    }
                                }
                            }, '删除')
                        ]);
                    }
                }
            ],
            t_data: [],
            pagination:{},
            menuData: [],
            listDetailId:0
        }
    },
    created(){
        // this.apiPermissionAll()
        this.apiPermissionList()
        this.terminalChange(this.editFormItem.terminal)
    },
    mounted(){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 175
    },
    methods:{
        changeLimit(val){
            this.limit=val
            this.apiPermissionList()
        },
        search(){
            this.page = 1
            this.apiPermissionList()
        },
        add(){
            this.terminalChange(this.editFormItem.terminal)
            this.$refs.formValidate.resetFields()
            this.title="添加权限"
            this.ModalShow = true
        },
        edit(id){
            this.apiPermissionAll()
            this.$refs.formValidate.resetFields()
            this.title="编辑权限"
            this.apiPermissionDetail(id)
            this.listDetailId = id
            this.ModalShow = true
        },
        remove(id){
            this.$Modal.confirm({
                title: '提示',
                content: '<p>是否删除该权限</p>',
                onOk: () => {
                    this.apiPermissionRemove(id)
                }
            });
        },
        terminalChange(value){
            this.apiPermissionAll(value)
        },

        apiPermissionAll(value){
            let params = {
                is_menu:1,
            }
            if(value) params.terminal = value
            serve.fetchGet(api.permissionAll,params).then(data => {
                console.log(data)
                this.menuData = this.permissionTree(data.dictionaries[0].child_permissions)  
            })
        },
        permissionTree(data,pid = 0){ 
            let arr = [
                {
                    value:pid,
                    label:"同级菜单",
                    children: []
                }
            ];
            if(data){
                for(let item of data){
                    if(item.child_permissions){
                        let child = this.permissionTree(item.child_permissions,item.id);
                        arr.push({
                            value: item.id,
                            label: item.show_name,
                            children: child
                        });

                    }else{
                        arr.push({
                            value: item.id,
                            label: item.show_name,
                            children: []
                        })
                    }
                }
            }
            return arr
        },
        apiPermissionList(){
            this.loading = true
            let params = {
                limit:this.limit,
                page:this.page,
                keywords:this.keywords
            }
            serve.fetchGet(api.permission,params).then(data => {
                // console.log(data)
                this.t_data = data.data
                this.pagination = data.meta.pagination
                this.loading = false
            }).catch((error)=>{
                this.loading = false
                this.$Message.error(error.response.data.message);
            })
        },
        apiPermissionAdd(){
            serve.fetchPost(api.permission,this.editFormItem).then(data => {
                // console.log(data)
                this.$Message.success('添加成功');
                this.ModalShow = false
                this.apiPermissionList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPermissionDetail(id){
            serve.fetchGet(api.permission+"/"+id,{}).then(data => {
                // console.log(data)
                this.editFormItem.is_menu = data.data.is_menu+""
                this.editFormItem.pids = data.data.pids
                this.editFormItem.pid = data.data.pid
                this.editFormItem.show_name = data.data.show_name
                this.editFormItem.sort = data.data.sort+""
                this.editFormItem.name = data.data.name
                this.editFormItem.icon = data.data.icon
                this.editFormItem.path=data.data.path
                this.editFormItem.terminal = data.data.terminal+''
                this.apiPermissionAll(data.data.terminal)
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPermissionEdit(){
            serve.fetchPut(api.permission+"/"+this.listDetailId,this.editFormItem).then(data => {
                // console.log(data)
                this.$Message.success('编辑成功');
                this.ModalShow = false
                this.apiPermissionList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiPermissionRemove(id){
            serve.fetchDelete(api.permission+"/"+id,{}).then(data => {
                // console.log(data)
                this.$Message.success('删除成功');
                this.ModalShow = false
                this.apiPermissionList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        close(){
            this.ModalShow = false
        },
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    if(this.title === '添加权限'){
                        this.apiPermissionAdd()
                        return
                    }
                    this.apiPermissionEdit()
                } else {
                    this.$Message.error('请完善表单');
                }
            })
        },
        pidChange(value, selectedData){
            this.editFormItem.pid = value[value.length-1]
        },
        changePage(page){
            this.page = page
            this.apiPermissionList()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/SystemSetting/System/permissions.vue